export default "__VITE_ASSET__CYRkgVDv__"